import {
  BaseChatAction,
  WaitingActions,
} from "@twiliointernal/e2-commons-shared-definitions";
import { useEffect, useState } from "react";
import {
  ActionButtonTypesEnum,
  WaitingInLineActionHandlers,
} from "./definitions";

const useSetWaitingInLineActions = (
  actions: WaitingActions,
  handlers: WaitingInLineActionHandlers
): BaseChatAction[] => {
  const [actionsToRender, setActionsToRender] = useState<BaseChatAction[]>([]);

  const { handleOpenModalSubmitTicket, handleShowPhoneNotificationForm } =
    handlers;

  useEffect(() => {
    // This function is used to setup the action handler for actions that could require it
    const setupActionMap = (
      actionKey: keyof WaitingActions,
      action: BaseChatAction
    ): BaseChatAction => {
      let actionButtonHandler = action.handleActionButtonClick || undefined;

      switch (actionKey) {
        case ActionButtonTypesEnum.TicketSubmission:
          actionButtonHandler = handleOpenModalSubmitTicket;
          break;

        case ActionButtonTypesEnum.RequestNotification:
          actionButtonHandler = handleShowPhoneNotificationForm;
          break;
      }
      const mappedAction: BaseChatAction = {
        ...action,
        handleActionButtonClick: actionButtonHandler,
      };
      return mappedAction;
    };

    if (actions) {
      const actionsToSet: BaseChatAction[] = (
        Object.entries(actions) as [keyof WaitingActions, BaseChatAction][]
      ).map(([actionKey, action]) => setupActionMap(actionKey, action));

      if (actionsToSet.length > 0) {
        setActionsToRender(actionsToSet);
      }
    }
  }, [actions]);

  return actionsToRender;
};

export default useSetWaitingInLineActions;
